interface IconProps {
	size?: number;
	strokeColor?: string;
	fillColor?: string;
}

function GreenTickIcon(props: IconProps) {
	const size: number = props.size || 24;
	const fillColor: string = props.fillColor || "#088264";
	const strokeColor: string = props.strokeColor || "#BEF3D9";
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
				fill={fillColor}
			/>
			<path
				d="M7.78223 12.6039L10.5947 15.4164L16.2197 9.38965"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function GreenCopyIcon(props: {}) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.4609 5.4457V4.8457C14.4609 3.18885 13.1178 1.8457 11.4609 1.8457H5.46094C3.80408 1.8457 2.46094 3.18885 2.46094 4.8457V10.8457C2.46094 12.5026 3.80408 13.8457 5.46094 13.8457H6.06094"
				stroke="#146C40"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<rect
				x="9.8457"
				y="10.1543"
				width="12"
				height="12"
				rx="3"
				fill="#146C40"
				stroke="#146C40"
			/>
		</svg>
	);
}

export { GreenTickIcon, GreenCopyIcon };
